import { Link } from 'react-router';
import { Card } from '../../../ui/misc';
import type { AttemptDetail } from '../types';

export function TicketEffects({ a }: { a: AttemptDetail }) {
  return (
    <>
      {(a.closedTickets.length > 0 || a.reopenedTickets.length > 0) && (
        <Card title={a.closedTickets.length ? 'Closed as done' : 'Reopened to Pending'}>
          <ul className="checklist">
            {[...a.closedTickets, ...a.reopenedTickets].map((t) => (
              <li key={t.key}>
                <Link to={`/projects/${a.project.key}/tickets/${t.number}`} className="mono">
                  {t.key}
                </Link>{' '}
                {t.title}
              </li>
            ))}
          </ul>
        </Card>
      )}
    </>
  );
}
